import React, { Component, Fragment } from 'react';
import ActiveSubscriptionsSelector from 'selectors/ActiveSubscriptionsSelector';
import get from 'lodash/get';
import Loading from 'components/Loading/Loading';
import { connect } from 'react-redux';
import { getPlan } from 'utils/stripePlanUtils';
import { fetchStripeCustomer } from 'actions/stripeCustomerActions';
import { updateUpsellData } from 'actions/userActions';
import { resubscribeMembership } from 'actions/stripeSubscriptionActions';
import { Link } from 'react-router';
import { BILLING_CYCLE, PLAN_LIMIT } from 'config/constants';
import './style.css';

class OfferLang7 extends Component {
  constructor(props) {
    super(props);

    const {
      user: {
        upsellData: { cycle }
      }
    } = this.props;

    let months = 0;
    if (cycle === BILLING_CYCLE.PREPAID_6) {
      months = 6;
    } else if (cycle === BILLING_CYCLE.PREPAID_12) {
      months = 12;
    }
    /*
    else if (cycle.includes('20')) {
      this.props.router.push('start')
      }
      */

    this.state = {
      months
    };
  }

  componentDidMount() {
    fbq('track', 'Offer-47'); // eslint-disable-line
    const {
      user: {
        upsellData: { cycle }
      }
    } = this.props;

    if (cycle.includes('20')) {
      this.updateUpsellData();
    }
    window.scrollTo(0, 0);

    const stripeCustomerId = get(this.props.user, 'profile.stripeCustomerId');
    this.props.fetchStripeCustomer(stripeCustomerId);
  }

  getSaleInfo = (cycle) => {
    let currentPlan;
    let upsellPlan;
    let hoursCount;
    let newPrice;
    let prepaid = false;

    switch (cycle) {
      case BILLING_CYCLE.MONTHLY_8:
        currentPlan = getPlan(BILLING_CYCLE.MONTHLY_8, PLAN_LIMIT.HOURS_4);
        upsellPlan = getPlan(BILLING_CYCLE.MONTHLY_12, PLAN_LIMIT.HOURS_6);
        newPrice = get(upsellPlan, 'price.month', 0) - 0.01;
        hoursCount = 6;
        break;
      case BILLING_CYCLE.MONTHLY_12:
        currentPlan = getPlan(BILLING_CYCLE.MONTHLY_12, PLAN_LIMIT.HOURS_6);
        upsellPlan = getPlan(BILLING_CYCLE.MONTHLY_20, PLAN_LIMIT.HOURS_10);
        hoursCount = 10;
        newPrice = get(upsellPlan, 'price.month', 0) - 0.01;
        break;
      case BILLING_CYCLE.PREPAID_8:
        currentPlan = getPlan(BILLING_CYCLE.PREPAID_8, PLAN_LIMIT.HOURS_4);
        upsellPlan = getPlan(BILLING_CYCLE.PREPAID_12, PLAN_LIMIT.HOURS_6);
        newPrice = get(upsellPlan, 'price.total', 0) / 6 - 0.01;
        hoursCount = 6;
        prepaid = true;
        break;
      case BILLING_CYCLE.PREPAID_12:
        currentPlan = getPlan(BILLING_CYCLE.PREPAID_12, PLAN_LIMIT.HOURS_6);
        upsellPlan = getPlan(BILLING_CYCLE.PREPAID_20, PLAN_LIMIT.HOURS_10);
        newPrice = get(upsellPlan, 'price.total', 0) / 6 - 0.01;
        hoursCount = 10;
        prepaid = true;
        break;
      default:
    }
    const salePrice = get(upsellPlan, 'price.month', 0) - get(currentPlan, 'price.month', 0);

    return {
      hoursCount,
      newPrice,
      prepaid,
      salePrice
    };
  }

  handleActivate = () => {
    const {
      activeStripeSubscription,
      user: {
        upsellData: { cycle }
      }
    } = this.props;

    const subscription = activeStripeSubscription.data;
    const { amount, status, stripeSubscriptionId } = subscription;
    const stripeCustomerId = get(this.props.user, 'profile.stripeCustomerId');
    const refundAmount = status === 'active' ? amount : 0;

    let newPlan;
    switch (cycle) {
      case BILLING_CYCLE.MONTHLY_8:
        newPlan = getPlan(BILLING_CYCLE.MONTHLY_12, PLAN_LIMIT.HOURS_6);
        break;
      case BILLING_CYCLE.MONTHLY_12:
        newPlan = getPlan(BILLING_CYCLE.MONTHLY_20, PLAN_LIMIT.HOURS_10);
        break;
      case BILLING_CYCLE.PREPAID_8:
        newPlan = getPlan(BILLING_CYCLE.PREPAID_12, PLAN_LIMIT.HOURS_6);
        break;
      case BILLING_CYCLE.PREPAID_12:
        newPlan = getPlan(BILLING_CYCLE.PREPAID_20, PLAN_LIMIT.HOURS_10);
        break;
      default:
    }
    if (newPlan) {
      this.props.resubscribeMembership(
        stripeCustomerId,
        stripeSubscriptionId,
        newPlan.id,
        refundAmount,
        () => this.props.fetchStripeCustomer(stripeCustomerId, this.updateUpsellData)
      );
    }
  }

  handleSkip = (event) => {
    event.preventDefault();
    this.updateUpsellData();
  }

  updateUpsellData = () => {
    this.props.updateUpsellData({
      ...this.props.user.upsellData,
      status: 'DONE'
    });
  }

  render() {
    const {
      activeStripeSubscription,
      stripeSubscription,
      user: {
        upsellData: { cycle }
      }
    } = this.props;

    const {
      hoursCount, newPrice, prepaid, salePrice
    } = this.getSaleInfo(cycle);

    return activeStripeSubscription.status === 'loading' ? (
      <Loading />
    ) : (
      <div className="offer-lang7 mx-auto my-5 p-4 px-sm-5">
        <div className="px-0 px-sm-4">
          <div className="offer-lang7__header">
            <h6 className="offer-lang7__header-title text-center mt-sm-3 mb-3">
              Want even faster results?
            </h6>
            <p className="m-0">
              Take this opportunity to get faster results by upgrading to our most popular plan,
              where you can book up to {hoursCount} hours of private{' '}
              <span className="text-nowrap">1-on-1</span> lessons per month.
            </p>
          </div>

          <div className="offer-lang7__divider my-4" />

          <div className="offer-lang7__plan text-center">
            New plan:
            <p className="m-0 mt-3">
              {hoursCount} hours/mo: +${salePrice}/mo
            </p>
          </div>

          <div className="offer-lang7__divider mt-4 mb-3" />

          {prepaid ? (
            <p className="offer-lang7__total m-0 text-center">
              New Total: ${newPrice}/mo (prepaid 6 months)
            </p>
          ) : (
            <p className="offer-lang7__total m-0 text-center">
              New Total: ${newPrice}/mo
              <br /> (6 monthly payments)
            </p>
          )}

          <div className="offer-lang7__action pt-3">
            <p className="offer-lang7__action-help text-center m-0">
              {cycle === BILLING_CYCLE.MONTHLY ?
                `You'll be billed +$${salePrice} today and on a monthly basis until you cancel.` :
                "You won't be charged until after your free week."}
            </p>
            {stripeSubscription.status === 'loading' ? (
              <Loading size="small" />
            ) : (
              <Fragment>
                <button
                  type="button"
                  className="btn btn-primary btn-lg btn-green btn-cursor w-100 mt-3 mb-4 px-2 py-sm-4"
                  onClick={this.handleActivate}
                >
                  Yes! Upgrade to {hoursCount} hours
                </button>
                <div className="text-center my-2">
                  <Link className="custom-link" to="#" onClick={this.handleSkip}>
                    No thanks, I don’t want faster results
                  </Link>
                </div>
              </Fragment>
            )}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    activeStripeSubscription: ActiveSubscriptionsSelector(state),
    stripeSubscription: state.stripeSubscription
  };
}

export default connect(
  mapStateToProps,
  {
    fetchStripeCustomer,
    updateUpsellData,
    resubscribeMembership
  }
)(OfferLang7);



// WEBPACK FOOTER //
// ./src/pages/student/OfferLang7/index.js